export const internalHosts = [
  "primark.com",
  "www.primark.com",
  "www.primarkgiftcards.com",
  // for local development
  "localhost:3000",
];
